import { useState } from "react";
import FaqItem from "./FaqItem";

const FaqSection = ({ faqs, labelData }) => {
  const [openId, setOpenId] = useState(null);

  return (
    <section className="max-w-7xl mx-auto md:px-4 mt-6">
      {/* Heading */}
      {/* <div className="text-center mb-6">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-800">
          {labelData}
        </h2>
        <div className="w-20 h-1 bg-orange-500 mx-auto mt-3 rounded-full"></div>
      </div> */}

      {/* FAQ List */}
      <div className="border border-gray-200 rounded-lg overflow-hidden">
        {faqs.map((faq) => (
          <FaqItem
            key={faq.id}
            faq={faq}
            isOpen={openId === faq.id}
            onToggle={() =>
              setOpenId(openId === faq.id ? null : faq.id)
            }
          />
        ))}
      </div>
    </section>
  );
};

export default FaqSection;